import { createClient } from '@supabase/supabase-js'
import { normalizeReportPayload } from '../utils/reportPayload';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase frontend configuration');
}

const supabaseFetch = async (input, init = {}) => {
  const url = typeof input === 'string' ? input : input?.url || String(input);
  const isReportsRequest = url.includes('/rest/v1/reports');

  if (!isReportsRequest || typeof init.body !== 'string') {
    return globalThis.fetch(input, init);
  }

  try {
    const parsedBody = JSON.parse(init.body);
    const normalizedBody = normalizeReportPayload(parsedBody);
    return globalThis.fetch(input, {
      ...init,
      body: JSON.stringify(normalizedBody),
    });
  } catch {
    return globalThis.fetch(input, init);
  }
};

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    fetch: supabaseFetch,
  },
});

export default supabase;
